import React, { useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import ExpenseDrawer from "./ExpenseDrawer";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import PrePaymentTable from "../PrePayment/PrepaymentTable";

function Expenses() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const expenseOptions = [
    { value: "travel", label: "Travel Expenses" },
    { value: "food", label: "Food Expenses" },
  ];

  const handleExpenseChange = (value) => {
    setSelectedExpense(value);
    setDrawerOpen(true);
  };


  return (
    <>
    <Card sx={{ pt: 4, pb:15, pl:4, borderRadius: 3, height:650, width:"100%"}}>
      <SoftBox mb={3}>
        <SoftTypography variant="h5" fontWeight="bold">
          Add Expense
        </SoftTypography>
      </SoftBox>

      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <SoftTypography variant="button" fontWeight="bold" color="text" onClick={() => setDrawerOpen(true)}>
            Select Expense Type
          </SoftTypography>
          <SoftSelect
            placeholder="Select Expense"
              options={expenseOptions}
              value={selectedExpense}
              onChange={handleExpenseChange}
          />
        </Grid>
      </Grid>
      <PrePaymentTable />
    </Card>

    <ExpenseDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        selectedType={selectedExpense?.value}
      />
      
      </>
  );
}

export default Expenses;





